import { EntityUpgrades, UnitType, UpgradeStatus, UpgradeType } from '../../../types/game-types';

export const upgrades: Partial<EntityUpgrades> = {
  multipleShot: {
    id: UpgradeType.MultipleShot,
    icon: ['bow6'],
    cost: { gold: 5000 },
    costGrowthRate: 20,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1,
    purchaseLimit: 4,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  huntersEye: {
    id: UpgradeType.HuntersEye,
    icon: ['bird', 'arrow1'],
    cost: { gold: 1000 },
    costGrowthRate: 1.9,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 20,
    purchaseLimit: 5,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  huntingSeason: {
    id: UpgradeType.HuntingSeason,
    icon: ['r_d_aim', 's_bird'],
    cost: { gold: 5000 },
    costGrowthRate: 2.0,
    purchased: 0,
    purchaseLimit: 10,
    multiplier: 0,
    bonusPerOwned: 3,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  silverArrow: {
    id: UpgradeType.SilverArrow,
    icon: ['silverBar', 'h_arrow2'],
    cost: { gold: 3000 },
    costGrowthRate: 1.4,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.1,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  goldenArrow: {
    id: UpgradeType.GoldenArrow,
    icon: ['goldBar', 'h_arrow1'],
    cost: { gold: 12000 },
    costGrowthRate: 2.1,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 40,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  iceArrow: {
    id: UpgradeType.IceArrow,
    icon: ['s_snow', 'h_v_arrow1'],
    cost: { gold: 30000 },
    costGrowthRate: 1.75,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1,
    purchaseLimit: 40,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  criticalChance: {
    id: UpgradeType.CriticalChance,
    icon: ['v_h_bow1', 'random'],
    cost: { gold: 8000 },
    costGrowthRate: 2,
    multiplier: 0,
    purchased: 0,
    purchaseLimit: 5,
    bonusPerOwned: 5,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  criticalDamage: {
    id: UpgradeType.CriticalDamage,
    icon: ['bang2', 's_v_bow1'],
    cost: { gold: 10000 },
    costGrowthRate: 2,
    multiplier: 2,
    purchased: 0,
    purchaseLimit: 10,
    bonusPerOwned: 1,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
};
